import { SweepConfig } from '../sweep/models'
import BaseApi from './base'
import { ChainlistModel } from './models'

class DictApi extends BaseApi {
  async getSweepConfig() {
    return this.get<SweepConfig>('/dict/getConfig')
  }
  async getBlockchainList() {
    return this.post<ChainlistModel[]>('/coin-blockchain-type/list')
  }
}
export default new DictApi()
